import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";

export default function NotFoundPage() {
  const { t, prefix } = useI18n();
  useEffect(() => {
    document.title = t.notFound.title;
    const m = document.createElement("meta");
    m.setAttribute("name", "robots");
    m.setAttribute("content", "noindex");
    document.head.appendChild(m);
    return () => m.remove();
  }, [t]);
  return (
    <main className="pt-44 pb-24 text-center px-6" data-testid="not-found-page">
      <div className="font-mono text-cyan-300 text-sm tracking-widest mb-4">404</div>
      <h1 className="font-display font-extrabold text-4xl sm:text-5xl text-white tracking-tighter">{t.notFound.heading}</h1>
      <p className="text-slate-400 mt-4 max-w-md mx-auto">{t.notFound.sub}</p>
      <Link
        to={prefix || "/"}
        data-testid="not-found-home-link"
        className="mt-8 inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/15 text-white font-medium px-6 py-3 rounded-xl"
      >{t.notFound.back}</Link>
    </main>
  );
}
